export const SALES_METRIC_SELECTOR = {
    SALES: 'CA',
    QUANTITY: 'UVC',
    CLIENTS: 'CARDHOLDERS'
};
//# sourceMappingURL=salesMetricSelector.type.js.map